




import styles from './AuditionCard.module.css';

const CATEGORY_STYLES = {
  '드라마':     { color: '#E07B1B', borderColor: '#E07B1B' },
  '웹드라마':   { color: '#E07B1B', borderColor: '#E07B1B' },
  '영화':       { color: '#2563EB', borderColor: '#2563EB' },
  '독립영화':   { color: '#2563EB', borderColor: '#2563EB' },
  '단편영화':   { color: '#2563EB', borderColor: '#2563EB' },
  '광고':       { color: '#7C3AED', borderColor: '#7C3AED' },
  '뮤지컬':    { color: '#059669', borderColor: '#059669' },
  '기타':       { color: '#6B7280', borderColor: '#6B7280' },
  '웹예능':     { color: '#0891B2', borderColor: '#0891B2' },
  '예능':       { color: '#0891B2', borderColor: '#0891B2' },
};

const GRADIENT_CATEGORIES = new Set(['TV(OTT)', 'OTT', '드라마(OTT)']);

function CategoryBadge({ category }) {
  if (GRADIENT_CATEGORIES.has(category)) {
    return (
      <span className={styles.categoryBadge} style={{ border: 'none', padding: '3px 8px' }}>
        <span style={{
          background: 'linear-gradient(90deg, #FFD92B, #FFB517)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          {category}
          
        </span>
      </span>
    );
  }
  const style = CATEGORY_STYLES[category] ?? { color: '#888896', borderColor: '#e9e9ec' };
  return <span className={styles.categoryBadge} style={style}>{category}</span>;
}

function getDDayColor(dDay) {
  if (!dDay) return '#888896';
  if (dDay === '마감') return '#888896';
  if (/^d-?day$/i.test(dDay)) return '#EF4444';
  const match = dDay.match(/-?(\d+)/);
  if (!match) return '#888896';
  const days = parseInt(match[1], 10);
  if (days <= 3) return '#EF4444';
  if (days <= 7) return '#F97316';
  return '#888896';
}

function AuditionCardHeader({ category, location, dDay, status, isNew, isClosing, isSaved, onSaveToggle }) {
  const handleSaveClick = (e) => {
    e.stopPropagation();
    onSaveToggle?.();
  };

  const isClosed = status === 'closed';
  const dDayColor = getDDayColor(dDay);
  return (
    <div className={styles.cardHeader}>
      <div className={styles.headerLeft}>
        {isClosed && <span className={styles.closedBadge}>마감</span>}
        {!isClosed && isClosing && <span className={styles.closingBadge}>마감임박</span>}
        {!isClosed && isNew && <span className={styles.newBadge}>NEW</span>}
        <CategoryBadge category={category} />
      </div>
      <div className={styles.headerRight}>
        {location && <span className={styles.location}>{location}</span>}
        {location && dDay && !isClosed && <span className={styles.headerDivider} />}
        {dDay && !isClosed && <span className={styles.dDay} style={{ color: dDayColor, fontWeight: dDayColor !== '#888896' ? 600 : 400 }}>{dDay}</span>}
        {onSaveToggle && (
          <button
            className={`${styles.saveButton} ${isSaved ? styles.saveActive : ''}`}
            onClick={handleSaveClick}
            aria-label={isSaved ? '저장 해제' : '저장하기'}
          >
            {isSaved ? (
              <svg width="18" height="20" viewBox="0 0 18 20" fill="currentColor" aria-hidden="true">
                <path d="M3 1h12a2 2 0 0 1 2 2v15.5l-8-4.5-8 4.5V3a2 2 0 0 1 2-2z"/>
              </svg>
            ) : (
              <svg width="18" height="20" viewBox="0 0 18 20" fill="none" aria-hidden="true">
                <path d="M3 1h12a2 2 0 0 1 2 2v15.5l-8-4.5-8 4.5V3a2 2 0 0 1 2-2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </button>
        )}
      </div>
    </div>
  );
}

export default AuditionCardHeader;
